// Runtime values come from /env-config.js, generated when the container starts (docker/40-env-config.sh),
// so one image serves every environment. import.meta.env is the fallback for `npm run dev` (.env); the
// image build gets no VITE_* values.
export const getEnvironmentVariable = (key: string): string => {
  const value = window.__ENV__?.[key] || import.meta.env[key];

  if (value === undefined || value === null || value === '') {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
};
